import $ from 'jquery';

$(function(){

	$('.scroll-animation').each(function(){
		
		var $el = $(this);
		var triggerTop = 0;
		var triggerBottom = 0;
		var repeatAnimation = $el.hasClass('repeat-animation');
		var enableAnimation = true;
		var inView = false;
		
		$(window).resize(function(){
			if(enableAnimation) {
				triggerTop = $el.offset().top - window.innerHeight;
				triggerBottom = $el.offset().top + $el.outerHeight();
			}
		}).trigger('resize');
		
		$(window).scroll(function(){
			if(enableAnimation) {
				requestAnimationFrame(function(){
					var sTop = $(window).scrollTop();
					if(!inView) {
						if((sTop >= triggerTop) && (sTop <= triggerBottom)) {
							inView = true;
							$el.addClass('in-view');
							if(!repeatAnimation) enableAnimation = false;
						}
					}
					else if(repeatAnimation) {
						if((sTop < (triggerTop - 75)) || (sTop > (triggerBottom + 75))) {
							inView = false;
							$el.removeClass('in-view');
						}
					}
				});
			}
		}).trigger('scroll');
		
	});
			
});